import { SearchUserEnriched } from 'lib-search-types';

import { isAgentAvailableOnPhoneChannel } from './isAgentAvailableOnThePhone';
import { isAgentOnThePhone } from './isAgentOnThePhone';

/** Checks whether it's possible to call an agent. */
export function isAgentAvailableForCall(member: SearchUserEnriched): boolean {
  return !isAgentOnThePhone(member) && isAgentAvailableOnPhoneChannel(member);
}
